export const booksOfAccountsColumns = [
  { key: 'transactedAt', text: 'Date', width: '8%' },
  { key: 'category', text: `Category`, width: '8%' },
  { key: 'account', text: `Account`, width: '15%' },
  { key: 'debit', text: `Debit`, width: '10%' },
  { key: 'credit', text: 'Credit', width: '10%' },
  { key: 'remarks', text: 'Remarks', width: '15%' },
  { key: 'options', text: ``, width: '10%' }
];
